import { render, staticRenderFns } from "./SendDetail_new.vue?vue&type=template&id=4bda8e24&scoped=true&"
import script from "./SendDetail_new.vue?vue&type=script&lang=js&"
export * from "./SendDetail_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bda8e24",
  null
  
)

export default component.exports